namespace Core {

  type pixelArgs = Core.RtbPixelArguments;

  class RtbHouseTracking {
    trackingUrl: string;

    constructor(
      private rtbHouseTrackingService: any,
      private $location: ng.ILocationService,
      private tripService: Core.TripService,
      private $routeParams: ng.route.IRouteParamsService,
      private $rootScope: any,
      private urlUtils: any,
      private regExpRoutes: any,
      private hotelSearch: any,
      private trackingPixelsService: any,
      private basketService: any,
      private currentDestination: any,
      private destinationService: any,
      private bookingCompleteTrackingService: any,
      private broker: any,
      private authService: any,
      private $q: any
    ) {
      this.$rootScope.$on('$routeChangeSuccess', () => {
        this.initTracking();

        // Need for check any update of currentUser object
        // * in some cases currentUser can be updated after complete load page
        this.broker.subscribe('rtbHouse', 'userSet', () => {
          this.initTracking();
        });
      });

      this.$rootScope.$on('auth:signout', () => {
        this.initTracking();
      });

      this.$rootScope.$on('auth:signin', () => {
        this.initTracking();
      });
    }

    checkCase(url, cases) {
      return this.rtbHouseTrackingService.boolFromMatch(url, cases);
    }

    initTracking() {
      const urlString = this.$location.url();
      const URL = this.urlUtils.stripLeadingSlash(urlString);
      const tripId = this.$routeParams.tripId || this.$location.search().tripId;
      const area = this.rtbHouseTrackingService.getCurrentArea(URL); // get currend area by url
      const {
        categoryCases,
        listingCases,
        holidayDeals,
        offerCases,
        cartCases,
        bookingCases,
        conversionCase
      } = this.regExpRoutes;

      if (urlString === '/') {
          this.trackingUrl = this.rtbHouseTrackingService.getHomeUrl();
      } else if (this.checkCase(URL, categoryCases)) {
          this.trackingUrl = this.rtbHouseTrackingService.getCategoryUrl(area);
      } else if (this.checkCase(URL, listingCases)) {
          this._getListingPixel(tripId, area);
      } else if (this.checkCase(URL, holidayDeals)) {
          this._getHolidayDealsPixel();
      } else if (this.checkCase(URL, offerCases)) {
          this._getOfferPixel(tripId, area);
      } else if (this.checkCase(URL, cartCases)) {
          this._getCartPixel(tripId, area);
      } else if (this.checkCase(URL, bookingCases)) {
          this._getBookingPixel(area);
      } else if (this.checkCase(URL, conversionCase)) {
          this._getConversionPixel(tripId);
      } else {
          this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
      }
    }

    private _getListingPixel(tripId, area) {
      // tracking pixels url for landing pages

      if (tripId) {
        this.tripService.getTrip(tripId).then(trip => {
          const data = this.rtbHouseTrackingService.getDataFromTrip(trip);
          if (!data) {
            this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
          } else {
            const promise = this.$q.when(this.hotelSearch.getSearchResults(data.searchId, tripId));

            promise.then(res => {
              let args: pixelArgs = {
                type:        'listing',
                area:        data.area,
                ids:         this.rtbHouseTrackingService.getIds(res.Hotels),
                destination: data.dest,
                checkin:     data.checkIn,
                checkout:    data.checkOut,
                adults:      data.adults,
                children:    data.children
              };

              if(trip.TripType === this.tripService.tripTypes.Flight) {
                args.class = data.class;
              }

              this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
            });
          }
        });

      } else {
        const promises = this.$q.all({
          details: this.currentDestination.getCurrentDestination().then(dest => {
              return this.destinationService.getDetails(dest);
            }),
          searchRes: this.hotelSearch.getStaticSearchResults()
        });

        promises.then(({ details, searchRes }) => {
          let args: pixelArgs = {
            type:        'listing',
            area:        area,
            ids:         this.rtbHouseTrackingService.getIds(searchRes.Hotels),
            destination: this.rtbHouseTrackingService.getAirportCodes(details.DestinationAirports),
            checkin:     this.rtbHouseTrackingService.formatDate(details.StartDate),
            checkout:    this.rtbHouseTrackingService.formatDate(details.EndDate),
            adults:      details && details.Adults ? details.Adults : 0,
            children:    details && details.ChildAges ? details.ChildAges.length : 0
          };

          this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
        });
      }
    }

    private _getHolidayDealsPixel() {
      this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
    }

    private _getOfferPixel(tripId, area) {
      // pixel for single offer page

      if (tripId) {
        this.tripService.getTrip(tripId).then(trip => {
          const data = this.rtbHouseTrackingService.getDataFromTrip(trip);
          if (!data) {
            this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
          } else {
            let args: pixelArgs = {
              type:        'offer',
              area:        data.area,
              destination: data.dest,
              checkin:     data.checkIn,
              checkout:    data.checkOut,
              adults:      data.adults,
              children:    data.children
            };

            if(trip.TripType === this.tripService.tripTypes.Flight) {
              let promise = this.$q.when(this.currentDestination.getCurrentDestination());

              promise.then(dest => {
                args.ids = this.rtbHouseTrackingService.topHotelId();
                args.destination = dest.DestinationAirports;

                this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
              });
            } else {

              this.broker.subscribe('rtbHouse', 'hotelCacheReady', ({data}) => {
                args.ids = data ? data.Id : null;
                this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
              });
            }
          }
        });
      } else {
        const promises = this.$q.all({
          details: this.currentDestination.getCurrentDestination().then(dest => {
            return this.destinationService.getDetails(dest);
          }),
          searchResult: this.hotelSearch.getStaticSearchResults()
        });

        promises.then(({ details, searchResult }) => {
          let args: pixelArgs = {
            type:        'offer',
            area:        area,
            ids:         this.rtbHouseTrackingService.getIds(searchResult.Hotels),
            destination: this.rtbHouseTrackingService.getAirportCodes(details.DestinationAirports),
            checkin:     this.rtbHouseTrackingService.formatDate(details.StartDate),
            checkout:    this.rtbHouseTrackingService.formatDate(details.EndDate),
            adults:      details ? details.Adults : 0,
            children:    details && details.ChildAges ? details.ChildAges.length : 0
          };

          this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
        });
      }
    }

    private _getCartPixel(tripId, area) {
        // pixel for option page

        if(tripId) {
          this.tripService.getTrip(tripId).then(trip => {
            const {BasketId, TripType} = trip;

            let args: pixelArgs = {
              type: 'basketstatus',
              area: this.rtbHouseTrackingService.tripStates[TripType] || area
            };

            if(trip.TripType === this.tripService.tripTypes.Flight) {
              args.ids = this.rtbHouseTrackingService.topHotelId();
              this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
            } else {

              this.$q.when(this.basketService.getHotel(BasketId)).then(hotel => {
                args.ids = hotel.Details ? hotel.Details.Id : null;

                this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
              });
            }
        });
      } else {
        this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
      }
    }

    private _getBookingPixel(area) {
      // pixel booking/option pages in holiday case

      if (!area) {
        this.trackingUrl = this.rtbHouseTrackingService.getDefaultUrl();
      }
      let args: pixelArgs = {
        type: 'startorder',
        area: area
      };

      this.trackingUrl = this.rtbHouseTrackingService.getPixelString(args);
    }

    private _getConversionPixel(tripId) {
      // conversion pixel for RTB House provider
    }
  }

  angular.module('core')
    .directive('rtbHouseTracking',
      function () {
        return {
          restrict: 'E',
          scope: {},
          template: `<img ng-if="rtb.trackingUrl" ng-src="{{rtb.trackingUrl}}"
                          width="1" height="1" style="position:absolute; bottom:0; display:none;" />`,
          controller: RtbHouseTracking,
          controllerAs: 'rtb'
        };
      });
}
